<div class="install-app-banner" *ngIf="showBanner" [class.install-app-banner--ios]="isIOS">
  <div class="install-app-banner__content">
    <span class="install-app-banner__message" *ngIf="!isIOS">{{ installMessage }}</span>
    <span class="install-app-banner__message" *ngIf="isIOS">
      {{ installMessage }} - Toque em 
      <i class="fas fa-share" style="font-size: 16px; margin: 0 4px;"></i> 
      e depois em "Adicionar à Tela Inicial"
    </span>
    <button class="install-app-banner__action" (click)="installApp()" *ngIf="!isIOS">
      <i class="fas fa-download"></i>
      <span>Instalar</span>
    </button>
  </div>
  <button class="install-app-banner__dismiss" (click)="dismissBanner()" aria-label="Fechar">
    <i class="fas fa-times"></i>
  </button>
</div>
